if (location.pathname.includes("/products/")) {
  document.addEventListener("DOMContentLoaded", function () {
    setTimeout(function () {
      if (!Currency.moneyFormats[Currency.currentCurrency]) {
        Currency.moneyFormats[Currency.currentCurrency] = {};
        Currency.moneyFormats[Currency.currentCurrency][Currency.format] = "";
      }
      const miniCartForm = document.querySelector("footer.atc-banner--cart-footer form.atc-banner__form[action^='/cart']:has(button[type='submit'])");
      const purchaseLateButton = miniCartForm.querySelector(".bss-b2b-customer-portal-nt-checkout-btn");
      const quoteButton = miniCartForm.querySelector(".bss-b2b-customer-portal-btn-quote-default");
      const shareCartButton = miniCartForm.querySelector(".bss-b2b-customer-portal-share-cart-btn");
    }, 2000);
  });
}

if (location.pathname.includes("/cart")) {
  document.addEventListener("DOMContentLoaded", function () {
    setTimeout(function () {
      const cartContainer = document.querySelector("#site-main");
      const additionalCheckoutButtons = document.querySelector(".cart-checkout .additional-checkout-buttons");
      const cartContinue = document.querySelector(".cart-checkout .cart-continue");

      cartContainer.appendChild(additionalCheckoutButtons);
      cartContainer.appendChild(cartContinue);
    }, 1000)
  })
}